import Typography from '@material-ui/core/Typography';
import { FC, ReactElement } from 'react';

import { ITeamMemberMapped } from '~/utils/clientAllocation';

import useAllocationConflictMessage from '../../../shared/hooks/useAllocationConflictMessage';
import useGetClientsGU from '../../../shared/hooks/useGetClientsGU';
import useClientAllocationsUpdate from '../../hooks/updateAllocations/useClientAllocationsUpdate';
import useAddAllocationAvailability from '../../hooks/validateAllocations/useAddAllocationAvailability';
import AllocationClientRowItem from '../ClientsRowItem/AllocationClientRowItem';
import AllocationClientsSelectGU from '../SelectFields/AllocationClientsSelectGU';

import layoutStyles from '../../../shared/components/EditAllocationFormLayout/EditAllocationFormLayout.module.scss';

interface IProps {
  teamMemberIdx: number;
  teamMember: ITeamMemberMapped;
}

const AllocationClientsListGU: FC<IProps> = ({ teamMemberIdx, teamMember }): ReactElement => {
  const {
    fields: clientsAllocationsFields,
    updateAllocations,
    removeClientAt,
  } = useClientAllocationsUpdate(teamMemberIdx);

  const { loadMore, loading, items: clientOptions } = useGetClientsGU(clientsAllocationsFields);

  useAddAllocationAvailability({
    clientsAllocations: clientsAllocationsFields.map(alloc => ({
      clientId: alloc.clientId,
      teamId: alloc.teamId ?? alloc.team?.id,
    })),
    userId: teamMember.id,
  });

  const { clientListConflict: conflictMessage } = useAllocationConflictMessage({ teamMemberIdx });

  return (
    <>
      {conflictMessage && (
        <Typography variant="body2" className={layoutStyles.conflictAlert}>
          {conflictMessage}
        </Typography>
      )}
      <Typography variant="subtitle1" className={layoutStyles.assignedClientsSectionTitle}>
        Client Allocations
      </Typography>

      <AllocationClientsSelectGU
        loading={loading}
        loadMore={loadMore}
        teamMemberIdx={teamMemberIdx}
        updateAllocations={updateAllocations}
      />

      {clientsAllocationsFields.map((field, clientIdx) => {
        const clientTeams = clientOptions.find(client => client.id === field.clientId)?.teams;

        return (
          <AllocationClientRowItem
            key={field.id}
            field={field}
            clientIdx={clientIdx}
            teamMemberIdx={teamMemberIdx}
            memberId={teamMember.id}
            onRemove={removeClientAt}
            availableClientTeams={clientTeams}
          />
        );
      })}
    </>
  );
};

export default AllocationClientsListGU;
